document.addEventListener('DOMContentLoaded', function() {
  function adjustSelectWidth(select) {
    if (!select) return;

    const tempSelect = document.createElement('select');
    const tempOption = document.createElement('option');
    tempSelect.style.cssText = 'position:absolute;visibility:hidden;width:auto;';
    tempSelect.appendChild(tempOption);
    document.body.appendChild(tempSelect);

    let maxWidth = 0;
    for (let i = 0; i < select.options.length; i++) {
      tempOption.textContent = select.options[i].text;
      const width = tempSelect.offsetWidth;
      if (width > maxWidth) maxWidth = width;
    }

    document.body.removeChild(tempSelect);
    select.style.width = (maxWidth + 40) + 'px';
  }

  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    adjustSelectWidth(sortSelect);
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        const newSortSelect = document.getElementById('SortBy');
        if (newSortSelect) {
          adjustSelectWidth(newSortSelect);
        }
      }
    });
  });

  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    observer.observe(productGridContainer.parentElement, {
      childList: true,
      subtree: true
    });
  }
});

(function() {
  function isBagTitle(title) {
    return title.toUpperCase().includes('BOLSA DE REGALO');
  }

  function getCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function removeBagsByBundleId(bundleId) {
    return getCart().then(function(cart) {
      var bags = cart.items.filter(function(i) {
        return isBagTitle(i.title) && i.properties && i.properties._BundleId === bundleId;
      });
      if (!bags.length) return false;
      var updates = {};
      bags.forEach(function(bag) { updates[bag.key] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function() { return true; });
    });
  }

  function addBagToCart(variantId, bundleId) {
    if (typeof window.addGiftToCart === 'function') {
      return window.addGiftToCart(variantId, bundleId);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: { _BundleId: bundleId }
      })
    });
  }

  function setProductBundleId(itemKey, bundleId) {
    return getCart().then(function(cart) {
      var item = cart.items.find(function(i) { return i.key === itemKey; });
      if (!item) return;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, properties: { _BundleId: bundleId } })
      });
    });
  }

  function setCartDrawerOverlay(visible) {
    if (typeof window.toggleCartDrawerOverlay === 'function') {
      window.toggleCartDrawerOverlay(visible);
    }
  }

  function initGiftBagItems() {
    var wrappers = document.querySelectorAll('.gift-bag-item-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.initialized === 'true') return;

      var isProcessing = false;

      var checkbox = wrapper.querySelector('.gift-bag-item-input');
      var priceLabel = wrapper.querySelector('.gift-bag-item-price-label');
      var itemKey = wrapper.dataset.itemKey;
      var giftVariantId = wrapper.dataset.giftVariantId;

      if (!checkbox || !giftVariantId) return;

      wrapper.dataset.initialized = 'true';

      function updatePriceLabel() {
        if (priceLabel && wrapper.dataset.giftPriceFormatted) {
          priceLabel.textContent = wrapper.dataset.giftPriceFormatted;
        }
      }

      updatePriceLabel();

      function getBundleId() { return wrapper.dataset.bundleId || ''; }
      function setBundleId(id) { wrapper.dataset.bundleId = id; }

      function done() {
        wrapper.classList.remove('updating');
        var refresh = typeof window.refreshCartDrawer === 'function'
          ? window.refreshCartDrawer()
          : Promise.resolve();
        Promise.resolve(refresh).finally(function() {
          isProcessing = false;
          setCartDrawerOverlay(false);
        });
      }

      function fail(label, err) {
        console.error(label, err);
        isProcessing = false;
        wrapper.classList.remove('updating');
        setCartDrawerOverlay(false);
      }

      function addLinkedBag() {
        var availableSlots = parseInt(wrapper.dataset.availableSlots || '0', 10);
        var linkedBags = parseInt(wrapper.dataset.currentBags || '0', 10);
        var bundleId = getBundleId();

        if (linkedBags > 0) return;

        if (availableSlots <= 0) {
          checkbox.checked = false;
          return;
        }

        setCartDrawerOverlay(true);
        isProcessing = true;
        wrapper.classList.add('updating');

        if (!bundleId) {
          var newBundleId = Date.now() + '_' + Math.floor(Math.random() * 1000);
          setBundleId(newBundleId);
          setProductBundleId(itemKey, newBundleId)
            .then(function() { return addBagToCart(giftVariantId, newBundleId); })
            .then(done)
            .catch(function(err) {
              checkbox.checked = false;
              setBundleId('');
              setProductBundleId(itemKey, '')
                .catch(function() {})
                .finally(function() { fail('Error adding bag:', err); });
            });
        } else {
          addBagToCart(giftVariantId, bundleId)
            .then(done)
            .catch(function(err) {
              checkbox.checked = false;
              fail('Error adding bag:', err);
            });
        }
      }

      checkbox.addEventListener('change', function(e) {
        e.stopPropagation();
        if (isProcessing) {
          this.checked = !this.checked;
          return;
        }

        if (this.checked) {
          addLinkedBag();
          return;
        }

        var bundleId = getBundleId();
        if (!bundleId) return;

        setCartDrawerOverlay(true);
        isProcessing = true;
        wrapper.classList.add('updating');

        removeBagsByBundleId(bundleId)
          .then(function(removed) {
            if (removed) return setProductBundleId(itemKey, '');
          })
          .then(function() {
            setBundleId('');
            done();
          })
          .catch(function(err) { fail('Error removing bags:', err); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftBagItems);
  } else {
    initGiftBagItems();
  }

  var giftBagObserver = new MutationObserver(function(mutations) {
    var shouldInit = false;
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        var hasGiftBag = Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 &&
            ((node.classList && node.classList.contains('gift-bag-item-wrapper')) ||
             (node.querySelector && node.querySelector('.gift-bag-item-wrapper')));
        });
        if (hasGiftBag) { shouldInit = true; break; }
      }
    }
    if (shouldInit) {
      setTimeout(function() {
        initGiftBagItems();
        if (window.initCartDrawerValidation) window.initCartDrawerValidation();
      }, 50);
    }
  });

  giftBagObserver.observe(document.body, { childList: true, subtree: true });
})();
